import { render, staticRenderFns } from "./UnitEditor.vue?vue&type=template&id=2d5dccc8&scoped=true&"
import script from "./UnitEditor.vue?vue&type=script&lang=js&"
export * from "./UnitEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5dccc8",
  null
  
)

export default component.exports